import SignalContent from "../signal_content";
import { SignallampSensorData } from "../../../types/types";

/*
  パネル画面側のアラート機能
*/
export function alarm(self: SignalContent, newSensorData: SignallampSensorData) {
  if (!newSensorData || newSensorData.alert_flag !== "true" || !self.useAlertSound) {
    return;
  }
  const mp3 = require("../../../../public/warning.mp3");
  const audio: HTMLAudioElement = new Audio(mp3);
  audio.play().catch((e) => {
    console.log(e);
    self.useAlertSound = false;
  });
}

/**
 * マッピング子コンポーネントの背景の点灯制御
 * @param self
 * @param newSensorData
 */
export function flashBackGround(self: SignalContent, newSensorData: SignallampSensorData) {
  if (newSensorData && newSensorData.alert_flag === "true" && newSensorData.alert_color_list) {
    const alertColor = newSensorData.alert_color_list[0];
    for (const key in self.backGroundAlertFlags) {
      if (key === alertColor) {
        self.backGroundAlertFlags[key] = true;
      }
    }
  } else {
    for (const key in self.backGroundAlertFlags) {
      self.backGroundAlertFlags[key] = false;
    }
  }
}
